import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '../../components/Layout/index';
import HeroBanner from '../../components/HeroBanner';
import Button from '../../components/Button';
import CTABanner from '../../components/CTABanner';

import MapSection from './components/MapSection';
import VisionSection from './components/VisionSection';
import RoleSection from './components/RoleSection';
import BenefitsSection from './components/BenefitsSection';
import FeedbackSection from './components/FeedbackSection';

import './style.scss';

const AboutPage = () => {
  return (
    <Layout pageTitle="About">
      <HeroBanner
        title="Annual Report 2020/21 Highlights"
        photo={
          <StaticImage
            className="shape shape-photo"
            src="./assets/hero-photo.png"
            alt="The Professional Standards Authority staff, Remashree Baniya"
            layout="fixed"
            width={738}
            quality={100}
          />
        }
      >
        <p>
          The Councils’ vision is that professional and occupational associations lead the way in advancing the highest
          standards of professional services to Australian consumers.
        </p>
        <Button color="primary" label="Read more about this chapter" icon="link" annualReportPage={24} />
      </HeroBanner>

      <MapSection />
      <VisionSection />
      <RoleSection />
      <BenefitsSection />
      <FeedbackSection />

      <CTABanner
        annualReportPage={24}
        cover={<StaticImage className="cover" src="./assets/cta-cover.jpg" alt="Professional Standards Councils' 2020/21 Annual Report About the councils chapter" width={192} />}
      />
    </Layout>
  );
};

export default AboutPage;
